<div class="min-h-screen flex flex-col">
    <app-header [isHome]="isHome" *ngIf="showHeaderAndFooter"/>
    <main class="flex-grow">
      <router-outlet />
    </main>
    <app-footer *ngIf="showHeaderAndFooter"/>
    <app-cart-toast></app-cart-toast>
  </div>